import { config } from 'env_def';
import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import IMInterceptor from './im_interceptor';
import { IMNotify } from './im_notify';
import { apis, environment, inWindow, supportLocalIndexedDB, isElectron } from '@/config';
import { imSession } from './im_eventemitter';
import { ImTeamManager } from './im_team';
import { SessionStream } from './im_sessionlist';
import { P2PMuteStream } from './im_p2pmutelist';
import { TeamMuteStream } from './im_teammutelist';
import { IM_CurrentSession } from './im_currentsession';
import { IM_PushNotify } from './im_pushmsg';
import { IM_Users } from './im_users';
import { IM_Self } from './im_myaccount';
import { IM_Later } from './im_sessionlater';
import { ImTeamStream } from './im_teamv2';
import { IM_Cache } from './im_cache';
import { wait } from '@/api/util';
import { locationHelper } from '@/api/util/location_helper';
import SiriusBDSocket from './bd_socket';
export const typeMapToNotificationContent = {
    text: '',
    image: '[图片]',
    file: '[文件]',
    custom: '[自定义消息]',
    video: '[视频]',
    audio: '[音频]',
    geo: '[位置]',
};
export const LINGXI_IM_TEAM_DEFAULT_NAME = 'LINGXI_IM_TEAM_DEFAULT_NAME_';
const env = typeof environment === 'string' ? environment : 'local';
const isDev = !['test_prod', 'prod', 'prev'].includes(env);
class NIMImplApi {
    constructor() {
        this.nimInstanceEvents = {};
        this.$instance = null;
        this.shouldUseBd = false;
        this.nimTempEventManager = imSession;
        this.yunxinInfo = undefined;
        this.appkey = config('NIMSID');
        this.loginStatus = 'logged';
        this.siriusBdSocket = null;
        this.hasAddOnlineEvent = false;
        this.interceptor = new IMInterceptor();
        this.teamManager = new ImTeamManager();
        this.imteamStream = new ImTeamStream();
        this.sessionStream = new SessionStream();
        this.p2pMuteStream = new P2PMuteStream();
        this.teamMuteStream = new TeamMuteStream();
        this.imself = new IM_Self();
        this.imlater = new IM_Later();
        this.imusers = new IM_Users();
        this.imnotify = new IMNotify();
        this.imcache = new IM_Cache();
        this.currentSession = new IM_CurrentSession();
        this.msgPushStream = new IM_PushNotify();
        this.interceptorMethods = new Set(['sendText', 'sendFile', 'sendTipMsg', 'sendCustomMsg', 'sendGeo', 'forwardMsg']);
        this.latestNIMServerTime = 0;
        this.checkYunxinAliveHanlder = 0;
        this.systemApi = masterApi.getSystemApi();
        this.xhr = masterApi.getDataTransApi();
        this.eventApi = masterApi.getEventApi();
        this.pushApi = masterApi.requireLogicalApi(apis.pushApiImpl);
        this.name = apis.imApiImpl;
        this.logger = masterApi.requireLogicalApi(apis.loggerApiImpl);
        this.accountApi = masterApi.requireLogicalApi(apis.accountApiImpl);
        this.scheduleApi = masterApi.requireLogicalApi(apis.catalogApiImpl);
        this.productAuthApi = masterApi.requireLogicalApi(apis.productAuthApiImpl);
        if (!inWindow() || window.isAccountBg || window.isBridgeWorker) {
            return;
        }
        this.siriusBdSocket = new SiriusBDSocket(this.systemApi, this.xhr, config('version'));
        try {
            this.imself.init(this);
            this.sessionStream.init(this);
            this.p2pMuteStream.init(this);
            this.teamMuteStream.init(this);
            this.currentSession.init(this);
            this.imusers.init(this);
            this.imlater.init(this);
            this.imteamStream.init(this);
            this.imnotify.init(this);
            this.teamManager.init(this);
            this.msgPushStream.init(this);
            this.imcache.init(this);
        }
        catch (error) {
            console.warn('[im] #### init error:', error);
        }
        this.subscrible('onconnect', (ev) => {
            this.onconnect(ev);
            this.eventApi.sendSysEvent({
                eventName: 'initModule',
                eventStrData: 'im',
            });
        });
        this.subscrible('ondisconnect', (ev) => {
            this.ondisconnect(ev);
        });
        this.subscrible('oncustomsysmsg', ev => {
            this.handleCustomerEvent(ev);
        });
    }
    getTeamName(_teamDetail) {
        throw new Error('Method not implemented.');
    }
    isImInited() {
        return NIMImplApi.connectStatus === 'success';
    }
    init() {
        this.initIm();
        return this.name;
    }
    async initBdSocket(token) {
        try {
            if (this.siriusBdSocket) {
                await this.siriusBdSocket.initBdSocket(token);
                this.siriusBdSocket.removeAllSubscribe();
                this.siriusBdSocket.addSubscribe(payload => {
                    this.handleBdCustomEvent({ content: payload });
                    return {};
                });
            }
        }
        catch (ex) {
            console.error('initBdSocket-ex');
        }
    }
    initIm() {
        if (!inWindow() || window.isAccountBg || window.isBridgeWorker) {
            return;
        }
        this.xhr.addConfig({
            matcher: /^\/(cowork|im)\/api\/biz\/.*/i,
            requestAutoReLogin(data) {
                const statusCode = lodashGet(data, 'status', '');
                const dataCode = lodashGet(data, 'data.code', '');
                return `${statusCode}` === '401' || ['401', '403'].includes(`${dataCode}`);
            },
            reLoginUrlHandler: conf => conf,
        });
        if (lodashGet(this.systemApi.getCurrentUser(), 'accountMd5.length', 0) === 0) {
            const eventApi = masterApi.getEventApi();
            const eid = eventApi.registerSysEventObserver('storeUserChangeEvent', {
                func: () => {
                    const len = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5.length', 0);
                    if (len > 0) {
                        eventApi.unregisterSysEventObserver('storeUserChangeEvent', eid);
                        this.initNIMInstance();
                    }
                },
            });
        }
        else {
            this.initNIMInstance();
        }
    }
    checkNIMInstanceAlive() {
        const maxCheckDuration = 10 * 60 * 1000;
        const handler = async () => {
            try {
                const latestNIMServerTime = (await this.excute('getServerTime'));
                console.log('[im]getServerTime', latestNIMServerTime);
                if (typeof latestNIMServerTime === 'number' && Number.isSafeInteger(latestNIMServerTime)) {
                    this.latestNIMServerTime = latestNIMServerTime;
                }
            }
            catch (ex) {
                console.log('[im]getServerTime.failed:', ex);
            }
        };
        const willReconnectCallback = async (source = 'reconnect') => {
            var _a;
            const now = Date.now();
            if (this.latestNIMServerTime === 0 || now - this.latestNIMServerTime < maxCheckDuration) {
                return;
            }
            console.warn('[im]willreconnect', now - this.latestNIMServerTime, '.source is:', source);
            this.destroyNIMInstanceAndStatus();
            this.unSubcrible('onwillreconnect', willReconnectCallback);
            if (lodashGet(this, 'yunxinInfo.yunxinToken.length', 0) !== 0) {
                await ((_a = this.$instance) === null || _a === void 0 ? void 0 : _a.connect());
                document.removeEventListener('visibilitychange', visibleChangeCallback);
                console.log('[im]willreconnect.ok1');
            }
            else {
                await this.initNIMInstance();
                console.log('[im]willreconnect.ok2');
            }
        };
        const visibleChangeCallback = async () => {
            if (document.visibilityState !== 'visible') {
                return;
            }
            await wait(1000);
            willReconnectCallback();
        };
        this.unSubcrible('onwillreconnect', willReconnectCallback);
        document.removeEventListener('visibilitychange', visibleChangeCallback);
        this.latestNIMServerTime = 0;
        this.checkYunxinAliveHanlder && this.systemApi.cancelEvent('mid', this.checkYunxinAliveHanlder);
        this.subscrible('onwillreconnect', willReconnectCallback);
        document.addEventListener('visibilitychange', visibleChangeCallback);
        this.checkYunxinAliveHanlder = this.systemApi.intervalEvent({
            eventPeriod: 'mid',
            handler,
            seq: 0,
        });
    }
    afterLogin(ev) {
        if (ev && ev.data) {
            this.initNIMInstance();
            this.loginStatus = 'logged';
        }
        return this.name;
    }
    beforeLogout() {
        this.destroyNIMInstanceAndStatus();
        this.loginStatus = 'unlogin';
        return this.name;
    }
    destroyNIMInstanceAndStatus() {
        var _a, _b, _c;
        try {
            (_a = this.$instance) === null || _a === void 0 ? void 0 : _a.disconnect();
        }
        catch (e) {
            console.warn(e);
        }
        try {
            (_b = this.$instance) === null || _b === void 0 ? void 0 : _b.destroy();
        }
        catch (e) {
            console.warn(e);
        }
        this.$instance = null;
        NIMImplApi.connectStatus = 'init';
        console.log('[im] im instance destroyed:', this);
        (_c = this.pushApi) === null || _c === void 0 ? void 0 : _c.triggerNotificationInfoChange({
            action: 'im_clear',
            content: '',
            num: 0,
            title: '',
        });
        this.clearStatus();
    }
    clearStatus() {
        this.yunxinInfo = undefined;
        console.warn('[im] --- im clear status:', this.$instance);
    }
    afterInit() {
        NIMImplApi.needInit = true;
        return this.name;
    }
    afterLoadFinish() {
        if (inWindow()) {
            const user = this.systemApi.getCurrentUser();
            console.log('[im] im will init , im got user:', user);
            if (user) {
                this.initNIMInstance();
            }
            this.watchNetwork();
        }
        return this.name;
    }
    onPathChange(ev) {
        var _a;
        if (((_a = ev === null || ev === void 0 ? void 0 : ev.curPath) === null || _a === void 0 ? void 0 : _a.pathname) === '/') {
            this.initIm();
            this.afterInit();
            this.afterLoadFinish();
        }
        return this.name;
    }
    watchNetwork() {
        if (this.hasAddOnlineEvent)
            return;
        window.addEventListener('online', () => {
            setTimeout(() => {
                this.systemApi.getCurrentUser() && this.initNIMInstance();
            }, 3000);
        });
        this.hasAddOnlineEvent = true;
    }
    isPathlegal() {
        return this.systemApi.isMainPage() || (!isElectron() && locationHelper.testPathMatch('jump', false));
    }
    async startInitBdSocket(retryCount = 0) {
        try {
            if (window.isInOtherApp)
                return;
            if (this.siriusBdSocket) {
                const tokenRes = await this.siriusBdSocket.getBdSocketToken();
                if (tokenRes) {
                    this.shouldUseBd = tokenRes.shouldUseBD;
                    if (this.shouldUseBd) {
                        this.initBdSocket(tokenRes.token);
                    }
                    return true;
                }
                else {
                    await wait(10000);
                    if (retryCount < 3) {
                        this.startInitBdSocket(retryCount + 1);
                    }
                }
                return false;
            }
            return false;
        }
        catch (ex) {
            return false;
        }
    }
    async initNIMInstance(retry) {
        if (!NIMImplApi.needInit || !this.isPathlegal() || !this.systemApi.getCurrentUser()) {
            return;
        }
        this.startInitBdSocket();
        const retryTime = retry || 0;
        if (!this.pushApi) {
            this.pushApi = masterApi.requireLogicalApi(apis.pushApiImpl);
        }
        console.log('[im] im init for :', NIMImplApi.connectStatus);
        if (NIMImplApi.connectStatus !== 'init') {
            return;
        }
        if (this.$instance && typeof this.$instance.connect !== 'undefined' && this.yunxinInfo) {
            this.destroyNIMInstanceAndStatus();
        }
        console.log('[im] im will init ,events:', this.nimInstanceEvents);
        NIMImplApi.connectStatus = 'ing';
        try {
            await wait(1000);
            await this.excuteConnect();
            NIMImplApi.connectStatus = 'success';
            console.log('[im] im instance inited');
            this.eventApi.sendSysEvent({
                eventName: 'initModule',
                eventStrData: 'im',
            });
        }
        catch (ex) {
            console.warn('[im] im instance initfailed:', ex);
            NIMImplApi.connectStatus = 'init';
            if (this.loginStatus === 'logged' && retryTime < 15) {
                await wait(30 * 1000);
                this.initNIMInstance(retryTime + 1);
            }
        }
    }
    async excuteConnect() {
        const shouldUseIM = this.getIMAuthConfig();
        if (!shouldUseIM) {
            return '';
        }
        const emailAddress = this.getEmailAccount();
        if (!emailAddress) {
            return Promise.reject('got email failed');
        }
        console.log('[im] init yun xin connection:' + emailAddress);
        this.yunxinInfo = await this.accountApi.getCurrentAccountInfo(emailAddress);
        if (!this.yunxinInfo) {
            return Promise.reject('got account failed');
        }
        console.log('[im] got yun xin info:', this.yunxinInfo);
        this.sdkInit(this.yunxinInfo.yunxinToken, this.yunxinInfo.yunxinAccountId, {});
        return '';
    }
    getEmailAccount() {
        const currentUser = this.systemApi.getCurrentUser();
        const id = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
        return id;
    }
    async sdkInit(token, account, options = {}) {
        let imAuthConfig = {};
        const enableUseCompleteIM = this.getIMAuthConfig();
        if (!enableUseCompleteIM) {
            imAuthConfig = {
                db: false,
                shouldIgnoreMsg() {
                    return true;
                },
            };
        }
        else if (!supportLocalIndexedDB()) {
            imAuthConfig = {
                db: false,
            };
        }
        try {
            const aNIMWebSDK = window.SDK;
            const NIM = aNIMWebSDK.NIM;
            const allOptions = Object.assign(options, this.nimInstanceEvents, {
                debug: environment !== 'prod',
                appKey: this.appkey,
                syncSessionUnread: true,
                token,
                account,
                syncStickTopSessions: true,
                shouldIgnoreNotification(msg) {
                    const shouldIgnore = lodashGet(msg, 'attach.type', '') === 'updateTeam' && lodashGet(msg, 'attach.team.serverCustom.length', 0);
                    const shouldRemoveMember = lodashGet(msg, 'attach.type', '') === 'removeTeamMembers';
                    return !!shouldIgnore || shouldRemoveMember;
                },
                shouldIgnoreMsg(msg) {
                    const shouldRemoveMember = lodashGet(msg, 'attach.type', '') === 'removeTeamMembers';
                    return shouldRemoveMember;
                },
            }, imAuthConfig);
            this.logger.track('im_init', { account, token });
            this.$instance = NIM.getInstance(allOptions);
        }
        catch (ex) {
            console.warn('[im] #### init failed', ex);
            if (!isDev) {
                throw new Error('--- init failed');
            }
        }
        return new Promise((resolve, reject) => {
            const tempConnectCallback = () => {
                resolve(true);
                this.unSubcrible('onconnect', tempConnectCallback);
                this.unSubcrible('ondisconnect', tempDisConnectCallback);
            };
            const tempDisConnectCallback = () => {
                this.unSubcrible('onconnect', tempConnectCallback);
                this.unSubcrible('ondisconnect', tempDisConnectCallback);
                reject();
            };
            this.subscrible('onconnect', tempConnectCallback);
            this.subscrible('ondisconnect', tempDisConnectCallback);
        });
    }
    getInstance() {
        return this.$instance;
    }
    onconnect(ev) {
        var _a;
        console.info('#### im connect', ev, (_a = this.$instance) === null || _a === void 0 ? void 0 : _a.options);
    }
    ondisconnect(ev) {
        var _a;
        this.logger.track('im_disconnect', ev);
        this.clearStatus();
        NIMImplApi.connectStatus = 'init';
        if (this.$instance && this.$instance.destroy) {
            try {
                (_a = this.$instance) === null || _a === void 0 ? void 0 : _a.destroy();
            }
            catch (ex) {
                console.warn(ex);
            }
        }
    }
    onerror(ev) {
        console.warn('got error:', ev);
        this.logger.track('im_error', ev);
    }
    async excute(command, options = {}, ...restArgs) {
        if (!this.$instance) {
            await new Promise((resolve, reject) => {
                const tempConnect = () => {
                    resolve(true);
                    this.nimTempEventManager.removeListener('onconnect', tempConnect);
                };
                const tempOndisconnect = () => {
                    reject();
                    this.nimTempEventManager.removeListener('ondisconnect', tempConnect);
                };
                this.subscrible('onconnect', tempConnect);
                this.subscrible('ondisconnect', tempOndisconnect);
            });
        }
        if (this.interceptorMethods.has(command)) {
            options = (await this.interceptor.request.excute(Promise.resolve([command, options])))[1];
        }
        const $this = this;
        const result = await new Promise((resolve, reject) => {
            try {
                this.$instance[command](Object.assign(Object.assign(Object.assign({}, options), (Reflect.has(options, 'custom')
                    ? {
                        custom: JSON.stringify(options.custom),
                    }
                    : {})), { async done(error, ...rest) {
                        if (error instanceof Error) {
                            return Reflect.has(options, 'done') ? options.done(error, ...rest) : reject(error);
                        }
                        let result = rest[0];
                        if ($this.interceptorMethods.has(command)) {
                            result = (await $this.interceptor.response.excute(Promise.resolve([command, options, ...rest])))[2];
                        }
                        return Reflect.has(options, 'done') ? options.done(error, ...rest) : resolve(result);
                    } }), ...restArgs);
            }
            catch (e) {
                reject(e);
            }
        });
        if (!Reflect.has(options, 'done')) {
            return Promise.resolve(result);
        }
        return true;
    }
    async excuteSync(command, ...restArgs) {
        if (!this.$instance) {
            await new Promise((resolve, reject) => {
                this.subscrible('onconnect', resolve);
                this.subscrible('ondisconnect', reject);
            });
        }
        const $ins = this.$instance;
        const $method = $ins[command];
        return Promise.resolve($method.apply($ins, restArgs));
    }
    getIMAuthConfig() {
        var _a;
        if (window.isInOtherApp)
            return false;
        const enableUseCompleteIM = this.productAuthApi.getAuthConfig('IM_SHOW') === null || ((_a = this.productAuthApi.getAuthConfig('IM_SHOW')) === null || _a === void 0 ? void 0 : _a.show) !== false;
        console.log('im_default_config is:', enableUseCompleteIM);
        return enableUseCompleteIM;
    }
    subscrible(event, callback) {
        console.log('[im] #### add event to im ,', event, callback);
        this.nimTempEventManager.repackageEvent(event, callback);
        if (this.nimTempEventManager.listenerCount(event) !== 1) {
            console.log('[im] #### event already exist :' + event);
            return callback;
        }
        console.log('[im] #### first event pass:', this.nimTempEventManager);
        const newCallback = (...args) => {
            this.nimTempEventManager.emit(event, ...args);
        };
        this.nimInstanceEvents[event] = newCallback;
        if (this.$instance && this.$instance.setOptions && typeof this.$instance.setOptions === 'function') {
            this.$instance.setOptions({
                [event]: newCallback,
            });
            console.log('[im] #### event added to im ,', event);
        }
        return callback;
    }
    unSubcrible(eventName, callback) {
        console.log('[im] #### im remove callback', eventName, callback);
        if (typeof callback !== 'function') {
            this.nimTempEventManager.removeAllListeners(eventName);
        }
        else {
            this.nimTempEventManager.removeListener(eventName, callback);
        }
    }
    subCustomEvent(eventname, callback, options = { once: false }) {
        this.nimTempEventManager[options.once ? 'once' : 'on'](eventname, callback);
    }
    offCustomEvent(eventName, callback) {
        this.nimTempEventManager.removeListener(eventName, callback);
    }
    emitCustomEvent(eventname, ...args) {
        this.nimTempEventManager.emit(eventname, ...args);
    }
    handleBdCustomEvent(ev) {
        let _contentObj = ev.content;
        if (typeof _contentObj !== 'string' && typeof (_contentObj === null || _contentObj === void 0 ? void 0 : _contentObj.body) === 'string') {
            _contentObj = _contentObj.body;
        }
        this.innerHandleCustomEvent(_contentObj);
    }
    innerHandleCustomEvent(content) {
        var _a;
        if (content) {
            const msg = JSON.parse(content);
            if (msg.subType === 'new_email') {
                const data = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data;
                const actionUrl = new URL((_a = data === null || data === void 0 ? void 0 : data.msgExt) === null || _a === void 0 ? void 0 : _a.actionUrl);
                const params = actionUrl.searchParams;
                const mailId = params.get('mailId') || '';
                const accountId = params.get('aid') || '';
                this.pushApi.triggerNotificationInfoChange({
                    content: data.msgTitle,
                    title: data.sendMailUser,
                    action: 'new_mail',
                    num: 1,
                    mailId,
                    accountId,
                });
            }
            else if (msg.subType === 'international_trade') {
                const msgData = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data;
                const { type, data } = msgData;
                if (type === 'WhatsAppIm') {
                    this.eventApi.sendSysEvent({
                        eventName: 'whatsAppMessagesUpdate',
                        eventStrData: 'whatsAppMessagesUpdate',
                        eventData: data,
                    });
                    (data.toList || []).forEach(chatId => {
                        try {
                            this.pushApi.triggerNotificationInfoChange({
                                title: 'WhatsApp 新消息',
                                content: '来自 WhatsApp 联系人的新消息',
                                action: 'whatsApp',
                                data: JSON.stringify({ chatId }),
                                num: 0,
                            });
                        }
                        catch (_a) { }
                    });
                    return;
                }
                if (type === 'WhatsAppMessageStatus') {
                    this.eventApi.sendSysEvent({
                        eventName: 'whatsAppMessageStatus',
                        eventStrData: 'whatsAppMessageStatus',
                        eventData: data,
                    });
                }
                if (type === 'WhatsAppImV2') {
                    this.eventApi.sendSysEvent({
                        eventName: 'whatsAppMessagesUpdateV2',
                        eventStrData: 'whatsAppMessagesUpdateV2',
                        eventData: data,
                    });
                    try {
                        this.pushApi.triggerNotificationInfoChange({
                            title: 'WhatsApp 新消息',
                            content: '来自 WhatsApp 联系人的新消息',
                            action: 'whatsApp',
                            data: JSON.stringify(data),
                            num: 0,
                        });
                    }
                    catch (_b) { }
                }
                if (type === 'WhatsAppMessageStatusV2') {
                    this.eventApi.sendSysEvent({
                        eventName: 'whatsAppMessageStatusV2',
                        eventStrData: 'whatsAppMessageStatusV2',
                        eventData: data,
                    });
                }
                if (type === 'FacebookNewMsg') {
                    this.eventApi.sendSysEvent({
                        eventName: 'facebookNewMessage',
                        eventStrData: 'facebookNewMessage',
                        eventData: msgData,
                    });
                    if (msgData.dialogList && msgData.dialogList[0]) {
                        const { pageId, contactId } = msgData.dialogList[0];
                        try {
                            const pushData = JSON.stringify({ pageId, contactId });
                            this.pushApi.triggerNotificationInfoChange({
                                title: 'Facebook 新消息',
                                content: '来自 Facebook 联系人的新消息',
                                action: 'facebook',
                                data: pushData,
                                num: 0,
                            });
                        }
                        catch (error) { }
                    }
                    return;
                }
                if (type === 'FacebookAccountExpires') {
                    this.eventApi.sendSysEvent({
                        eventName: 'facebookAccountExpires',
                        eventStrData: 'facebookAccountExpires',
                        eventData: msgData,
                    });
                }
                if (type === 'FacebookSync30DayFinish') {
                }
                if (type === 'SocialMediaNewMsg') {
                    this.eventApi.sendSysEvent({
                        eventName: 'socialMediaNewMsg',
                        eventStrData: 'socialMediaNewMsg',
                        eventData: msgData,
                    });
                }
                if (type === 'SystemTaskNewTask') {
                    this.eventApi.sendSysEvent({
                        eventName: 'SystemTaskNewTask',
                        eventStrData: 'SystemTaskNewTask',
                        eventData: msgData,
                    });
                }
                if (type === 'SystemTaskStatusUpdate') {
                    this.eventApi.sendSysEvent({
                        eventName: 'SystemTaskStatusUpdate',
                        eventStrData: 'SystemTaskStatusUpdate',
                        eventData: msgData,
                    });
                }
                if (type === 'TaskStatusUpdateV2') {
                    this.eventApi.sendSysEvent({
                        eventName: 'TaskStatusUpdateV2',
                        eventStrData: 'TaskStatusUpdateV2',
                        eventData: msgData,
                    });
                }
                if (type === 'regular-customer-task' || type === 'privilege-grant-redPoint') {
                    this.eventApi.sendSysEvent({
                        eventName: 'regularCustomerMenuUpdate',
                        eventData: msgData,
                    });
                }
                if (type === 'ai-assistant-unread-reddot') {
                    this.eventApi.sendSysEvent({
                        eventName: 'AiAssistantUnreadReddot',
                        eventData: msgData,
                    });
                }
                if (type === 'total-unread-reddot') {
                    this.eventApi.sendSysEvent({
                        eventName: 'TotalUnreadReddot',
                        eventData: msgData,
                    });
                }
                if (type === 'marketing-expert-unread-reddot') {
                    this.eventApi.sendSysEvent({
                        eventName: 'MarketingExpertUnreadReddot',
                        eventData: msgData,
                    });
                }
                if (type === 'build-website-expert-unread-reddot') {
                    this.eventApi.sendSysEvent({
                        eventName: 'BuildWebsiteExpertUnreadReddot',
                        eventData: msgData,
                    });
                }
                if (type === 'operation-expert-unread-reddot') {
                    this.eventApi.sendSysEvent({
                        eventName: 'OperationExpertUnreadReddot',
                        eventData: msgData,
                    });
                }
                if (type === 'social-media-expert-unread-reddot') {
                    this.eventApi.sendSysEvent({
                        eventName: 'SocialMediaExpertUnreadReddot',
                        eventData: msgData,
                    });
                }
                if (type === 'global-linghang-collect-unread') {
                    this.eventApi.sendSysEvent({
                        eventName: 'anomalyMonitoringCountUpdate',
                        eventData: {
                            count: (msgData === null || msgData === void 0 ? void 0 : msgData.count) || 0,
                        },
                    });
                }
            }
            else if (msg.subType === 'customer_update') {
            }
            else if (msg.subType === 'calendar_update') {
                if (isElectron()) {
                    const data = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data;
                    this.scheduleApi.initScheduleNotice(data);
                }
            }
            else if (msg.subType === 'whatsapp_red_dot') {
                const data = typeof msg.data === 'string' ? JSON.parse(msg.data) : msg.data;
                this.eventApi.sendSysEvent({
                    eventName: 'whatsappSubscribeUpdate',
                    eventData: {
                        type: 'reddot',
                        reddot: Boolean(data.redDot),
                        unreadCount: (data === null || data === void 0 ? void 0 : data.unreadCount) || 0,
                    },
                });
            }
        }
    }
    handleCustomerEvent(ev) {
        console.log('[im] #### receive from im , email event catch im info:', ev);
        const { content } = ev;
        if (this.shouldUseBd)
            return;
        this.innerHandleCustomEvent(content);
    }
}
NIMImplApi.inited = false;
NIMImplApi.needInit = false;
NIMImplApi.connectStatus = 'init';
const NIMImplApiInstance = new NIMImplApi();
const nimInstanceImpl = new Proxy(NIMImplApiInstance, {
    get(target, property) {
        if (target[property]) {
            return target[property];
        }
        if (target.$instance && target.$instance[property]) {
            return target.$instance[property];
        }
        return undefined;
    },
});
masterApi.registerLogicalApi(nimInstanceImpl);
export default nimInstanceImpl;
